import { Component, Input, OnInit } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { UserService } from 'src/app/account/services/user.service';
import { DrawerService } from 'src/app/drawer/services/drawer.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})
export class ToolbarComponent implements OnInit {
  @Input() drawerRefer;
  showToolbar = false;
  userName: string;
  routerDrawerAllowed = {
    home: 1,
    membro: true,
    area: true,
    setor: true,
    celula: true,
    patrimonio: true,
    frequencia: true,
    dashboard: true,
    palavra: true,
    'minha-conta': true,
    crianca: true,
    changePassword: true,
    banners: true,
    permissoes: true,
    devocional: true,
  };

  constructor(private router: Router, private drawerService: DrawerService) {
    this.drawerRefer = drawerService.getDrawerAllowedRoutes();
    this.userName = sessionStorage.getItem('userName');
    router.events.subscribe((event: Event) => {
      if (!this.routerDrawerAllowed[window.location.href.split('/')[3]]) {
        this.showToolbar = false;
      } else {
        if (this.routerDrawerAllowed[window.location.href.split('/')[3]]) {
          this.showToolbar = true;
        }
      }
      if (event instanceof NavigationStart) {
        this.showToolbar = true;
        return;
      }
    });
  }

  ngOnInit(): void {}

  toggleDrawer() {
    this.drawerRefer.toggle();
  }
}
